import React, { createContext, useContext, useState, useCallback } from 'react';

const ThemeContext = createContext({
    isDarkMode: false,
    toggleTheme: () => {},
    getEnhancedThemeClasses: () => ({}),
    getColorTheme: () => ({}),
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Default to Light Mode as per the new design's light theme focus
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleTheme = useCallback(() => {
        setIsDarkMode(prev => !prev);
    }, []);

    // These functions mock the Tailwind utility lookups required by the new Dashboard component
    const getEnhancedThemeClasses = useCallback((isDark) => ({
        bgCard: isDark ? 'bg-gray-800' : 'bg-white',
        textPrimary: isDark ? 'text-white' : 'text-gray-900',
        textSecondary: isDark ? 'text-gray-400' : 'text-gray-500',
        textMuted: isDark ? 'text-gray-500' : 'text-gray-400',
        pageBg: isDark ? 'bg-gray-900' : 'bg-white',
        divider: isDark ? 'border-gray-700' : 'border-gray-200',
        textAccent: 'text-purple-500',
        glow: 'hover:shadow-glow-purple', // Assuming tailwind.config has glow-purple
    }), []);

    const getColorTheme = useCallback((color, isDark) => {
        const baseColor = color === 'pink' ? 'pink' : color === 'green' ? 'green' : color === 'blue' ? 'blue' : 'purple';
        return {
            gradient: `from-${baseColor}-500 to-${baseColor}-700`, 
            border: `border-${baseColor}-400`,
            icon: 'text-white',
            shadow: `shadow-${baseColor}-500/30`
        };
    }, []);

    const value = { 
        isDarkMode, 
        toggleTheme,
        getEnhancedThemeClasses,
        getColorTheme
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};